var _path, _path2, _path3, _g, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPresentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7754 2.20213C16.4263 1.98216 15.9971 1.9627 15.6313 2.14883L14.3963 2.77235C13.9396 3.00247 13.6562 3.46778 13.6562 3.98555V8.8468C13.6562 9.36456 13.9396 9.82903 14.3963 10.0608L15.6304 10.6835C15.7979 10.7698 15.9771 10.8113 16.1563 10.8113C16.3713 10.8113 16.5846 10.7504 16.7754 10.6311C17.1246 10.4119 17.333 10.0321 17.333 9.61583V3.2182C17.333 2.80196 17.1246 2.42209 16.7754 2.20213Z",
    fill: "#F9B42A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92075 12.6667H4.09404C2.07568 12.6667 0.666504 11.275 0.666504 9.28259V3.55078C0.666504 1.55755 2.07568 0.166687 4.09404 0.166687H8.92075C10.9391 0.166687 12.3483 1.55755 12.3483 3.55078V9.28259C12.3483 11.275 10.9391 12.6667 8.92075 12.6667Z",
    fill: "#FFCC66"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1125_3328",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92075 12.6667H4.09404C2.07568 12.6667 0.666504 11.275 0.666504 9.28259V3.55078C0.666504 1.55755 2.07568 0.166687 4.09404 0.166687H8.92075C10.9391 0.166687 12.3483 1.55755 12.3483 3.55078V9.28259C12.3483 11.275 10.9391 12.6667 8.92075 12.6667Z",
    fill: "#FFA64D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1125_3328)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.19336,
    y: -5.83698,
    width: 9.16667,
    height: 19.1667,
    transform: "rotate(42.018 6.19336 -5.83698)",
    fill: "#FFA64D"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4165 4.33337V8.08338",
    stroke: "white",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.7d73264c.svg";
export { ForwardRef as ReactComponent };